require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./feature-the-rio-revel-review.json") })
        }
      }, "path---feature-the-rio-revel-review");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---feature-the-rio-revel-review!./.cache/json/feature-the-rio-revel-review.json
// module id = 647
// module chunks = 231608221292675